let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aqhu3")).then(() => parcelRequire('6cRc4'));